import { createSlice } from "@reduxjs/toolkit";
import { E_TipoParavento, E_MainLato } from "../../components/Utils/enumerations";

export const uiParaventiSlice = createSlice({
    name: "UI_paraventi",
    initialState: {
        isVisible: false,
        tipoParavento: E_TipoParavento.Slim_100.toString(),
        latiParaventi: [
            {lato: E_MainLato.Lato1.toString(),
            parav: false},
            {lato: E_MainLato.Lato2.toString(),
            parav: false},
            {lato: E_MainLato.Lato3.toString(),
            parav: false},
            {lato: E_MainLato.Lato4.toString(),
            parav: false},
        ],
        porta: 0,
        lunghezzaParaventi: 0,
    },
    reducers: {
        setParaventiMenuVisible: (state, action) => {            
            state.isVisible = action.payload;         
        },  
        handleParaventiTipo: (state, action) => {
            state.tipoParavento = action.payload;         
        },
        handleParaventiLato: (state, action) => {     
            const elementIndex = state.latiParaventi.findIndex(el => el.lato === action.payload.lato);
            state.latiParaventi = state.latiParaventi.map((el, ind) => ind === elementIndex ? action.payload : el);         
        },
        handleParaventiPorta: (state, action) => {
            state.porta = action.payload;
        }, 
        setLunghezzaParaventi: (state, action) => {
            state.lunghezzaParaventi = action.payload;
        }       
    }
});

export const { setParaventiMenuVisible,         
                handleParaventiTipo,
                handleParaventiLato,
                handleParaventiPorta,   
                setLunghezzaParaventi,                     
} = uiParaventiSlice.actions;

export default uiParaventiSlice.reducer;